import React from "react";
import {Link} from "react-router-dom";


export default function WebLink(props){

	const {children, ...rest} = props;

	const to = props?.to ?? props?.href
	
	if(!to){ return <div /> }
	
	return <Link to={to} {...rest} >{children}</Link>

}

